export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-format@1.4.5@d3-format/src/identity.js
// module id = null
// module chunks = 